// UX50 (docs/build-briefs/UX50-capitalize-appended-server-message.md).
// Dependency-free, no `window`/`document` access, same shape
// sizeTokens.ts already uses, so a plain `node:test` file can import
// capitalizeServerMessage directly with no DOM shim.
//
// Every floor and admin error toast/status line in main.ts and admin.ts
// composes a fixed, capitalized lead sentence with a server-supplied
// `message` (or `error`, or a stringified status) appended as a second
// sentence, e.g. `Could not load the menu. ${body.message ?? "..."}`.
// The server's own refusal text (harness/src/domain/permissions.ts,
// InsufficientRightsError's "this action is not available to your
// current role...") is written to read correctly ALONE, so it starts in
// lower case; appended after a capitalized lead sentence it reads as one
// run-on sentence with a lower-case restart ("...the menu. this action
// is..."). capitalizeServerMessage capitalizes only the first letter of
// whatever is appended, leaving every other character (including a
// message that already starts upper-case, or one starting with a digit
// or punctuation) untouched, so it is safe to apply unconditionally at
// every composition site rather than only the ones already known to hit
// this bug.
export function capitalizeServerMessage(message: string): string {
  if (message.length === 0) {
    return message;
  }
  const first = message.charAt(0);
  const capitalized = first.toUpperCase();
  if (capitalized === first) {
    return message;
  }
  return capitalized + message.slice(1);
}
